/*
 * Copyright © 2020-2025 XCamera. All Rights Reserved.
 * @Description:
 * @LastEditors: yingongjing
 * @LastEditTime: 2025-08-11 15:11:16
 */
// AI识别模块TypeScript类型定义
import { RefObject } from 'react'
import { XCImageSelectionEditorRef } from '../../components/ImageSelectionEditor'

/**
 * 识别状态常量映射
 */
export const XC_RECOGNITION_STATUS = {
  WAITING: 'waiting',
  RECOGNIZING: 'recognizing',
  COMPLETED: 'completed'
} as const

/**
 * 识别状态类型
 */
export type XCRecognitionStatus = typeof XC_RECOGNITION_STATUS[keyof typeof XC_RECOGNITION_STATUS]

/**
 * 识别结果接口
 */
export interface XCRecognitionResult {
  id: number
  potentialHazardList: string[]
  standardList: string[]
  thinking: string
  createdAt?: string
  userID?: string
  groupID?: string
  msg?: string
}

// 识别记录数据类型（基于API返回结构）
export interface RecognitionRecord {
  id: number
  url?: string
  potentialHazardList?: string[]
  standardList?: string[]
  thinking?: string
  userID?: string
  groupID?: string
  nickName?: string
  createTime?: string
}

/**
 * 导出数据接口
 */
export interface XCRecognitionExportDataResult {
  exportURL: string
  fileName?: number
}

/**
 * 选择区域信息接口
 */
export interface XCSelectionInfo {
  x: number
  y: number
  width: number
  height: number
}

/**
 * 安全隐患场景接口
 */
export interface XCSafetyScenario {
  id: string
  name: string
  description?: string
  selected: boolean
}

/**
 * AI识别状态接口
 */
export interface XCAIRecognitionState {
  selectedImages: string[]
  recognitionResult?: XCRecognitionResult
  recognitionStatus: XCRecognitionStatus
  selectionInfo?: XCSelectionInfo[]
  /** 选中的安全场景 */
  selectedSafetyScenarios: XCSafetyScenario[]
  /** 安全场景列表 */
  safetyScenarioList: XCSafetyScenario[]
  userId: string | null | undefined
  groupId: string | null
  isGroupVIP: boolean
  myRole: string | number
  imageSelectionEditorRef?: RefObject<XCImageSelectionEditorRef>
  /** 记住本次选择 */
  rememberChoice: boolean
  /** 安全场景选择Modal状态 */
  showSafetyScenarioModal: boolean
}

/**
 * AI识别操作接口
 */
export interface XCAIRecognitionActions {
  /** 设置选中的图片 */
  setSelectedImages: (url: string[]) => void
  setRecognitionResult: (result?: XCRecognitionResult) => void
  setRecognitionStatus: (status: XCRecognitionStatus) => void
  setSelectionInfo: (info: XCSelectionInfo[]) => void
  /** 设置图片选择编辑器的引用 */
  setImageSelectionEditorRef: (
    ref: RefObject<XCImageSelectionEditorRef>
  ) => void
  /** 设置选中的安全场景 */
  setSelectedSafetyScenarios: (scenarios: XCSafetyScenario[]) => void
  /** 设置安全场景列表 */
  setSafetyScenarioList: (scenarios: XCSafetyScenario[]) => void

  /** 开始识别 */
  startRecognition: () => void

  /** 更新参考标准 */
  updateReferenceStandard: (value: string[]) => void

  /** 更新思考过程 */
  updateThinkingProcess: (value: string) => void

  /** 更新记住本次选择 */
  setRememberChoice: (value: boolean) => void

  /** 安全场景Modal操作 */
  setShowSafetyScenarioModal: (visible: boolean) => void
}

/**
 * Context完整接口
 */
export interface XCAIRecognitionContext
  extends XCAIRecognitionState,
    XCAIRecognitionActions {}

/**
 * AI识别头部组件Props
 */
export interface XCAIRecognitionHeaderProps {
  onRecognitionHistory?: () => void
  loading?: boolean
}
